import React from 'react';
import { Container, Typography } from '@mui/material';
import { Box } from '@mui/system';
import {
    PanierPaiementJsonldLienpaiementpanierCreate,
    TblCollectionDossierJsonldPanierunitaireRead,
    TblDossier2JsonldPanierunitaireRead,
    TblFacture2JsonldPanierunitaireRead,
    TblPanierReglementJsonldPanierunitaireRead,
} from '@europrocurement/l2d-domain/openApi/ApiFacturation';
import { CenterCircularProgress } from '@europrocurement/flexy-components';
import PanierErrorLien from '../PanierErrorLien/PanierErrorLien';
import PanierReglement from '../PanierReglement/PanierReglement';
import { usePaiementApi } from '../../../hooks/usePaiementApi';
import { L2DRLogoIcon } from '../L2DRLogoIcon/L2DRLogoIcon';
import { L2DPLogoIcon } from '../L2DPLogoIcon/L2DPLogoIcon';

export type PanierType = {
    uuid: string;
    type?: 'recouvrement' | 'paiement';
};
const Panier: React.FunctionComponent<PanierType> = function ({ uuid, type = 'paiement' }) {
    const { panierPaiementApi, env } = usePaiementApi();

    const [panier, setPanier] = React.useState<TblPanierReglementJsonldPanierunitaireRead | null>(
        null,
    );
    const [error, setError] = React.useState<boolean>(false);

    const [errorLien, setErrorLien] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (
            uuid &&
            uuid.trim() !== '' &&
            (!panier || !panier.uuid || panier.uuid.toUpperCase() !== uuid.toUpperCase())
        ) {
            panierPaiementApi
                .apiPublicPanierReglementIdGet({
                    id: uuid,
                    xIdSociete: 12,
                })
                .then((res) => {
                    setPanier(res.data);
                })
                .catch((err) => {
                    setError(true);
                    console.log(err);
                });
        }
    }, [uuid, panier, panierPaiementApi]);

    if (errorLien) {
        return (
            <PanierErrorLien
                env={env}
                error="traitement"
                type={type}
            />
        );
    }
    if (error) {
        return (
            <PanierErrorLien
                env={env}
                error="indisponible"
                type={type}
            />
        );
    }
    return panier && panier?.id !== undefined ? (
        <Container>
            {env !== 'prod' ? (
                <Box
                    id="env-ribbon"
                    className={`${env}`}
                >
                    {env}
                </Box>
            ) : null}
            <Box sx={{ textAlign: 'center' }}>
                {type === 'paiement' ? <L2DPLogoIcon /> : <L2DRLogoIcon />}
            </Box>
            <PanierReglement
                type={type}
                panier={panier}
                elementsSelectionnables
                onClick={(id, collectionsSelected, dossiersSelected, facturesSelected) => {
                    const panierPaiementJsonldLienpaiementpanierCreate: PanierPaiementJsonldLienpaiementpanierCreate =
                        {
                            // customerEmail: 'llc@europroc.net',
                            normalReturnUrl: `${window.location.origin}/paiement-valide`,
                            cancelResponseUrl: `${window.location.origin}/paiement-invalide`,
                            origine: 13,
                            collections: (collectionsSelected ?? [])
                                .map((c: TblCollectionDossierJsonldPanierunitaireRead) => c.id)
                                .filter(
                                    (idCollection): idCollection is number =>
                                        idCollection !== undefined,
                                ),
                            dossiers: (dossiersSelected ?? [])
                                .map((c: TblDossier2JsonldPanierunitaireRead) => c.id)
                                .filter(
                                    (idDossier): idDossier is number => idDossier !== undefined,
                                ),
                            factures: (facturesSelected ?? [])
                                .map((c: TblFacture2JsonldPanierunitaireRead) => c.id)
                                .filter(
                                    (idFacture): idFacture is number => idFacture !== undefined,
                                ),
                            id: panier?.id || null,
                        };
                    panierPaiementApi
                        .apiPublicPanierReglementLienPost({
                            panierPaiementJsonldLienpaiementpanierCreate,
                            xIdSociete: 12,
                        })
                        .then((res) => {
                            if (
                                res.data?.payResponseUrl != null &&
                                res.data.payResponseUrl !== ''
                            ) {
                                window.location.href = res.data.payResponseUrl;
                            } else {
                                setErrorLien(true);
                                console.log('payResponseUrl is null or undefined', res.data);
                            }
                        })
                        .catch((err) => {
                            setErrorLien(true);
                            console.log(err);
                        });
                }}
            />
        </Container>
    ) : (
        <CenterCircularProgress
            title={
                <Typography
                    variant="l2dh7"
                    sx={{ marginRight: '10px', fontSize: '0.875rem' }}
                >
                    Panier en cours de chargement
                </Typography>
            }
        />
    );
};
export default Panier;
